import React, { FC } from "react";


export const Html:
    FC<
        React.DetailedHTMLProps<
            React.HTMLAttributes<HTMLDivElement>,
            HTMLDivElement
        > & { tag?: string; content?: string; }
    > =
    ({ tag, content, children, ...props }) =>
    {
        return React.createElement(tag ?? "div", { dangerouslySetInnerHTML: { __html: content ?? children }, ...props });
    };
